module.exports = __webpack_public_path__ + "4d865409cf09969c4d765105a50dd493.png";